import React from 'react';
import Hero from './Hero';
import MainContent from './MainContent';
import SponsorsSection from './SponsorsSection';
import ImageGallery from './ImageGallery';

const Home = () => {
  return (
    <>
      <Hero />
      <MainContent />
      <SponsorsSection />
      <ImageGallery />
    </>
  );
};

export default Home;